import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SettingField } from "@/components/settings/setting-field";
import { FormControl, FormField, FormItem } from "@/components/ui/form";
import { Switch } from "@/components/ui/switch";
import type { SaveField } from "../../../hooks/use-auto-save-field";
import { OnlineBookingConfig } from "../hooks/use-online-booking-config";

export function AllowBookingPastClosingToggle({
  saveField,
  saving,
}: {
  saveField: SaveField<OnlineBookingConfig>;
  saving: boolean;
}) {
  const { control } = useFormContext<OnlineBookingConfig>();
  const { t } = useTranslation("settings");

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="allowBookingPastClosing"
        render={({ field }) => (
          <FormItem>
            <SettingField
              label={t("onlineBooking.fields.allowBookingPastClosing.label")}
              helpText={t("onlineBooking.fields.allowBookingPastClosing.helpText")}
            >
              <FormControl>
                <Switch
                  checked={field.value}
                  disabled={saving}
                  onCheckedChange={(value) => {
                    void saveField("allowBookingPastClosing", value);
                  }}
                />
              </FormControl>
            </SettingField>
          </FormItem>
        )}
      />
    </div>
  );
}
